import api from 'api';
export const participants = {
  autoLogin(success) {
    const token = localStorage.getItem('participant_token');
    if (token && token.length) {
      api.token = token;
      success(token);
    }
  },
  login(code, participantId, password, success, fail) {
    api.unauthenticatedRequest('POST', '/participants/sessions', { code, participantId, password }, (data) => {
      localStorage.setItem('participant_token', data.token);
      api.token = data.token;
      success(data);
    }, fail);
  },
  localLogout(success) {
    localStorage.removeItem('participant_token');
    success && success();
  },
  logout(success, fail) {
    api.authenticatedRequest('DELETE', '/participants/sessions', null, () => {
      localStorage.removeItem('participant_token');
      success && success();
    }, fail);
  },
  me(success, fail) {
    api.authenticatedRequest('GET', '/participants/me', null, success, fail);
  },
  getTrialStages(trialId, success, fail) {
    api.authenticatedRequest('GET', `/participants/trials/${trialId}/stages`, null, success, fail);
  },
  getTrialStage(trialId, stageId, success, fail) {
    api.authenticatedRequest('GET', `/participants/trials/${trialId}/stages/${stageId}`, null, success, fail);
  },
};
